"use client";

import React from "react";
// Import all possible section components here
import AiCallAgentServicesCardSection from "../sections/ai-call-agent/AiCallAgentServicesCardSection";
import OnboardingProcess from "../sections/ai-call-agent/OnboardingProcess";
import PerformanceHub from "../sections/ai-call-agent/PerformanceHub";
import WebsiteDevelopmentServicesCardSection from "../sections/website-develoopment/WebsiteDevelopmentServicesCardSection";
import FeaturesTabs from "../sections/website-develoopment/FeaturesTabs";
import SoftwareTechStack from "../sections/software-development/SoftwareTechStack";
import GameGenres from "../sections/game-development/GameGenres";
import ApiAAS from "../sections/api-development/ApiAAS";
import WebsocketUpgrade from "../sections/custom-software-integration/WebsocketUpgrade";
import FilterGridSection from "../sections/common/FilterGridSection";
import ArchitectSection from "../sections/common/ArchitectSection";
import AlternatingSection from "../sections/common/AlternatingSection";
import TabSection from "../sections/common/TabSection";


import { useServiceData } from "../hooks/useServiceData";

/**
 * Maps section types from the backend to frontend components.
 */
const sectionComponents = {
  featureGridSection: FeaturesTabs, // Backend uses this for the "We are the Experts" tabs
  processSection: FeaturesTabs, // Backend uses this for the tab-style features section
  performanceHubSection: PerformanceHub,
  websiteServicesSection: WebsiteDevelopmentServicesCardSection,
  cardGridSection: AiCallAgentServicesCardSection, // Mapping for general card grids
  techStackSection: SoftwareTechStack, // Mapping for the "Advanced Technologies" section
  gamesGridSection: GameGenres, // Mapping for the Game Genre selection grid
  splitFeatureSection: ApiAAS, // Mapping for the Split Feature / API-as-a-Service section
  websocketSection: WebsocketUpgrade, // Mapping for the Websocket Upgrade section
  filterGridSection: FilterGridSection, // Mapping for the sidebar tech stack grid
  combinedSection: ArchitectSection, // Mapping for the radial architecture section
  alternatingSection: AlternatingSection, // Mapping for the zigzag feature section
  tabSection: TabSection, // Mapping for the center-image feature section
  // Add more mappings as new types are created in the backend
};

export default function ExtraSectionsDispatcher({ fallback }) {
  const { data: backendPageData } = useServiceData();
  const extraSections = backendPageData?.extraSections || [];

  if (!extraSections || extraSections.length === 0) return fallback || null;

  return (
    <>
      {extraSections.map((section, index) => {
        const { type, refId } = section;
        const Component = sectionComponents[type];

        if (!Component) {
          console.warn(`No component found for section type: ${type}`);
          return null;
        }

        // Pass refId as 'dynamicData' prop to the component
        return <Component key={`${type}-${index}`} dynamicData={refId} />;
      })}
    </>
  );
}
